class ScriptLoader {

  // scripts is an array of objects.
  // Each object has an event, selector, src, and callback properties.
  constructor(scripts) {
    if (scripts.length <= 0) return;
    this.scripts = scripts;
    this.bindEvents();
  }

  bindEvents() {
    // 1. Bind events for each script where the selector's length isn't 0.
    this.scripts.forEach( script => {
      const selectedElements = document.querySelectorAll(script.selector);
      if (selectedElements.length <= 0) return;

      // IE11
      if (!!window.MSInputMethodContext && !!document.documentMode) {
        this.insertScript(script);
        return;
      }

      switch (script.event) {
        case 'scroll':
          window.addEventListener('scroll', () => { this.insertScript(script) }, {once: true});
          break;

        case 'load':
          window.addEventListener('load', () => { this.insertScript(script) })
          break;

        default:
          break;
      }

    });
  }
  
  
  insertScript(script) {

    // 1. Check if script has already been inserted.
    const existingScript = document.querySelector(`script[src="${script.src}"]`);

    if (existingScript) {
      let existingCallback = existingScript.onload;

      existingScript.onload = () => { script.callback(); existingCallback() };
      existingScript.onreadystatechange = () => { script.callback(); existingCallback() };
      return;
    }

    // 2. Create the script element.
    let newScript = document.createElement('script');
    newScript.onload = () => { script.callback() };
    newScript.onreadystatechange = () => { script.callback() };
    newScript.type = 'text/javascript';
    newScript.async = true;
    newScript.src = script.src;

    // 3. Prepend script to the body.
    let body = document.querySelector('body');
    body.appendChild(newScript);
  }
}